import { gettext } from '@eventbrite/i18n';

export const TOS_CREATE_ACCOUNT_MUST_BE_ACCEPTED = gettext(
    'To create account you have to accept our Terms and conditions. To continue press Create account',
);

export const TOS_SET_PASSWORD_MUST_BE_ACCEPTED = gettext(
    'To set a password you have to accept our Terms and conditions. To continue press Update Password',
);

export const TOS_SOCIAL_MUST_BE_ACCEPTED = gettext(
    'To continue you have to accept our Terms and conditions.',
);

export const TOS_PASSWORDLESS_MUST_BE_ACCEPTED = gettext(
    'To continue you have to accept our Terms and conditions.',
);
